import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Settings } from "lucide-react";
import { cn } from "@/lib/utils";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@homy/ui";
import { HomyLogo } from "@/components/brand/HomyLogo";
import { ViewSwitcher } from "@/components/views/ViewSwitcher";
import { AppNavSections } from "./AppNavSections";

export function AppMobileDrawer({
  open,
  onOpenChange,
  navGroups,
  openGroups,
  onToggleGroup,
  onNavigate,
}) {
  const { t } = useTranslation(["common", "nav"]);
  const location = useLocation();

  if (!open) return null;

  return (
    <Sheet open onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        className="w-64 p-0 flex flex-col"
        showOverlay
      >
        <SheetHeader className="p-4 border-b border-border shrink-0">
          <SheetTitle className="text-foreground">
            <HomyLogo collapsed={false} />
          </SheetTitle>
        </SheetHeader>
        <div
          data-testid="drawer-view-switcher"
          className="px-4 py-3 border-b border-border min-[480px]:hidden shrink-0"
        >
          <p className="text-overline uppercase font-semibold text-muted-foreground mb-2">
            {t("views.section", "Workspace View")}
          </p>
          <ViewSwitcher className="w-full justify-center" />
        </div>
        <nav
          className="flex-1 py-4 px-3 space-y-1 overflow-y-auto"
          aria-label={t("nav.mainNavigation")}
        >
          <AppNavSections
            groups={navGroups}
            collapsed={false}
            groupPresentation="inline"
            openGroups={openGroups}
            onToggleGroup={onToggleGroup}
            pathname={location.pathname}
            onNavigate={onNavigate}
          />
        </nav>
        <div className="p-4 border-t border-border space-y-1">
          <button
            type="button"
            onClick={() => onNavigate("/settings")}
            aria-label={t("nav.settings")}
            aria-current={location.pathname === "/settings" ? "page" : undefined}
            className={cn(
              "w-full flex items-center gap-3 px-3 py-2.5 min-h-[44px] rounded-xl cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
              location.pathname === "/settings"
                ? "bg-primary/12 text-primary"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            <Settings size={18} aria-hidden />
            <span className="text-sm font-semibold">
              {t("nav.settings")}
            </span>
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
